import React, { useContext, useState, useEffect } from 'react'
import './header.sass'
import { DarkModeContext } from '../../global/Theme'
import { useSelector, useDispatch } from 'react-redux'


import MobileNotification from '../../components/common/MobileNotification'


export default function Header({ img, text, handleClick }) {
    const { isDark } = useContext(DarkModeContext);
    const isNotificationActive = useSelector(state => state.navbarState.notification)
    const notification = useSelector(state => state.notification)

    const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);
    const [bodyHeight, setBodyHeight] = useState(document.body.clientHeight);
    const updateView = (v) => {
        if (v <= 580) {
            // document.getElementById('desktopNav').style.display = "flex";
            // console.log("hum chupa rahe hai header.js")
            document.getElementById('mainWrapper').classList.add('zero-bottom-padding')
        }

        else {
            // document.getElementById('desktopNav').style.display = "flex";
            document.getElementById('mainWrapper').classList.remove('zero-bottom-padding')
        }

    }

    useEffect(() => {
        updateView(window.innerWidth)
        return () => {
            document.getElementById('desktopNav').style.display = "flex";
            document.getElementById('mainWrapper').classList.remove('zero-bottom-padding')
        }
    }, [])

    useEffect(() => {
        window.addEventListener('resize', v => {
            setBodyHeight(document.body.clientHeight);
            setBodyWidth(document.body.clientWidth);
        })
        updateView(bodyWidth)

        return () => window.removeEventListener('resize', v => {
            setBodyHeight(document.body.clientHeight);
            setBodyWidth(document.body.clientWidth);
        })
    }, [bodyWidth, bodyHeight])



    return (
        <div className={`lover-header ${isDark ? 'lover-header-dark' : 'lover-header-light'}`}>
            {notification.isEnabled && <MobileNotification text={notification.text} icon={notification.icon} />}

            {handleClick ? <img onClick={handleClick} src={require(`../../assets/icons/${img}`)} /> : <img src={require(`../../assets/icons/${img}`)} />}
            <h1>{text}</h1>
        </div>
    )
}
